import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgEmailWarning(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.921 52.968a6 6 0 0 1 3.407-4.689L59.02 33.423a12 12 0 0 1 10.76.288l26.184 14.027a6 6 0 0 1 3.12 6.033L93.98 94.603a6 6 0 0 1-5.954 5.256h-63.17a6 6 0 0 1-5.953-6.744l5.018-40.147Z"
        fill="#42A486"
      />
      <path
        d="m65.334 75.157 30.472-16.413A6.272 6.272 0 0 0 99.056 54l1.835-12.23.005-.043a6.272 6.272 0 0 0-3.262-6.307L71.855 21.61a12.544 12.544 0 0 0-11.247-.3L29.299 35.984a6.272 6.272 0 0 0-3.561 4.901l-1.835 12.23c-.309 2.469.866 4.918 3.001 6.194l26.045 15.57a12.544 12.544 0 0 0 12.385.277Z"
        fill="#00664F"
      />
      <path
        d="M33.477 39.242a2.4 2.4 0 0 1 2.381-2.102h55.426a1.8 1.8 0 0 1 1.786 2.023L87.708 82.06a6 6 0 0 1-5.953 5.255h-47.49a6 6 0 0 1-5.954-6.744l5.166-41.329Z"
        fill="#F1F5F9"
      />
      <path
        d="M54.172 69.375a12.545 12.545 0 0 0 12.385.278l24.34-13.112-3.19 25.519a6 6 0 0 1-5.952 5.256h-47.49a6 6 0 0 1-5.954-6.745l3.1-24.802 22.76 13.606Z"
        fill="#CCD5E1"
      />
      <path
        d="M24.857 99.86h63.17a6 6 0 0 0 5.953-5.257l5.074-40.592a6.272 6.272 0 0 1-3.248 4.734L65.334 75.158a12.544 12.544 0 0 1-12.385-.277L26.904 59.31c-2.135-1.276-3.31-3.726-3.001-6.194l-5 39.998a6 6 0 0 0 5.954 6.744Z"
        fill="#80CCB5"
      />
      <path
        d="M24.857 99.86h63.17a6 6 0 0 0 5.953-5.257l5.074-40.592a6.272 6.272 0 0 1-3.248 4.734L65.334 75.158a12.544 12.544 0 0 1-12.385-.277L26.904 59.31c-2.135-1.276-3.31-3.726-3.001-6.194l-5 39.998a6 6 0 0 0 5.954 6.744Z"
        fill="#78B441"
      />
      <path
        d="M87.786 99.859H25.164c-3.772 0-6.691-3.307-6.223-7.05l.004-.03a5.236 5.236 0 0 1 2.26-3.659l26.084-17.623 5.66 3.383a12.544 12.544 0 0 0 12.385.277l6.036-3.251 20.051 16.077a7.058 7.058 0 0 1 2.589 6.382 6.309 6.309 0 0 1-.45 1.674 6.274 6.274 0 0 1-5.774 3.82Z"
        fill="#599F40"
      />
      <path
        d="M25.164 99.86h62.622a6.272 6.272 0 0 0 6.224-5.494 6.045 6.045 0 0 0-2.897-5.939L64.676 72.623a12 12 0 0 0-11.848-.265l-31.5 16.966a4.608 4.608 0 0 0-2.387 3.486c-.468 3.743 2.45 7.05 6.223 7.05Z"
        fill="#78B441"
      />
      <path
        d="M17.74 37.89a.8.8 0 0 1 .983-.56l1.913.524a.8.8 0 0 1-.423 1.543l-1.913-.524a.8.8 0 0 1-.56-.983Zm4.198-8.782a.8.8 0 0 1 1.127.099l2.015 2.403a.8.8 0 0 1-1.226 1.028l-2.015-2.403a.8.8 0 0 1 .099-1.127Zm7.891.84-.102-1.88a.8.8 0 1 1 1.597-.086l.102 1.879a.8.8 0 0 1-1.597.087ZM109.478 40.993a.8.8 0 0 0-.826-.773l-1.983.065a.801.801 0 0 0 .053 1.6l1.983-.066a.8.8 0 0 0 .773-.826Zm-.842-9.159a.8.8 0 0 0-1.119-.166l-2.518 1.869a.8.8 0 0 0 .953 1.285l2.518-1.869a.8.8 0 0 0 .166-1.119Zm-10.03-.35.535-1.803a.8.8 0 1 0-1.533-.456l-.536 1.804a.8.8 0 1 0 1.533.456Z"
        fill="#0F172A"
      />
      <path
        d="m58.992 45.773-8.686 12.464c-1.207 1.732-.025 4.102 2.109 4.225l15.878.92c2.134.123 3.582-2.094 2.582-3.955l-7.193-13.383c-.966-1.797-3.524-1.945-4.69-.271Z"
        fill="#FC0"
      />
      <path
        d="M61.5 59.007a.917.917 0 1 1-1.832-.106.917.917 0 0 1 1.831.105ZM61.457 55.528l.563-5.519c.059-.584-.33-1.098-.853-1.129-.523-.03-.968.436-.977 1.023l-.078 5.547c-.006.403.272.735.631.756.359.021.673-.277.714-.678Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgEmailWarning)
